// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lnd-header.header-reconstruction {
  position: sticky;
  top: 0;
  left: auto;
  right: auto;
  z-index: 40;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: max(clamp(16px, 3vw, 24px), env(safe-area-inset-left));
  padding-right: max(clamp(16px, 3vw, 24px), env(safe-area-inset-right));
  background: rgba(255, 255, 255, 0.95);
  border-bottom: 1px solid #e2e8f0;
  backdrop-filter: blur(8px);
}

.lnd-header__bar {
  max-width: 1120px;
  min-height: 64px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.lnd-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: #0f172a;
  text-decoration: none;
}

.lnd-brand__mark {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid rgba(14, 165, 233, 0.2);
  background: #e0f2fe;
  color: #0ea5e9;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lnd-brand__name {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.desktop-navigation {
  display: block;
}

.lnd-nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lnd-nav__link,
.lnd-nav__ghost,
.lnd-nav__primary,
.mobile-dropdown-item,
.mobile-dropdown-login {
  font-family: inherit;
  cursor: pointer;
}

.lnd-nav__link {
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 10px;
}

.lnd-nav__link:hover {
  color: #0ea5e9;
}

.lnd-nav__ghost,
.lnd-nav__primary {
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}

.lnd-nav__ghost {
  margin-left: 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #334155;
}

.lnd-nav__ghost:hover {
  background: #f8fafc;
  color: #0f172a;
}

.lnd-nav__primary {
  border: 0;
  background: #0ea5e9;
  color: #fff;
}

.lnd-nav__primary:hover {
  background: #0284c7;
}

.mobile-navigation {
  display: none;
}

.mobile-menu-toggle {
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.mobile-dropdown {
  display: none;
}

.mobile-dropdown.visible {
  display: block;
  padding-bottom: 12px;
}

.mobile-dropdown-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 1120px;
  margin: 0 auto;
}

.mobile-dropdown-item,
.mobile-dropdown-login {
  width: 100%;
  text-align: start;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
}

.mobile-dropdown-item {
  border: 0;
  background: transparent;
  color: #334155;
}

.mobile-dropdown-login {
  border: 0;
  background: #0ea5e9;
  color: #fff;
  font-weight: 600;
}

@media (max-width: 900px) {
  .desktop-navigation {
    display: none;
  }

  .mobile-navigation {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PageHeader/LandingHeader/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,WAAW;EACX,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,oEAAoE;EACpE,sEAAsE;EACtE,qCAAqC;EACrC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;EAKE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".lnd-header.header-reconstruction {\n  position: sticky;\n  top: 0;\n  left: auto;\n  right: auto;\n  z-index: 40;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-left: max(clamp(16px, 3vw, 24px), env(safe-area-inset-left));\n  padding-right: max(clamp(16px, 3vw, 24px), env(safe-area-inset-right));\n  background: rgba(255, 255, 255, 0.95);\n  border-bottom: 1px solid #e2e8f0;\n  backdrop-filter: blur(8px);\n}\n\n.lnd-header__bar {\n  max-width: 1120px;\n  min-height: 64px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.lnd-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  color: #0f172a;\n  text-decoration: none;\n}\n\n.lnd-brand__mark {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid rgba(14, 165, 233, 0.2);\n  background: #e0f2fe;\n  color: #0ea5e9;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lnd-brand__name {\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.desktop-navigation {\n  display: block;\n}\n\n.lnd-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.lnd-nav__link,\n.lnd-nav__ghost,\n.lnd-nav__primary,\n.mobile-dropdown-item,\n.mobile-dropdown-login {\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.lnd-nav__link {\n  border: 0;\n  background: transparent;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 8px 10px;\n}\n\n.lnd-nav__link:hover {\n  color: #0ea5e9;\n}\n\n.lnd-nav__ghost,\n.lnd-nav__primary {\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.lnd-nav__ghost {\n  margin-left: 12px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  color: #334155;\n}\n\n.lnd-nav__ghost:hover {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.lnd-nav__primary {\n  border: 0;\n  background: #0ea5e9;\n  color: #fff;\n}\n\n.lnd-nav__primary:hover {\n  background: #0284c7;\n}\n\n.mobile-navigation {\n  display: none;\n}\n\n.mobile-menu-toggle {\n  width: 36px;\n  height: 36px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mobile-dropdown {\n  display: none;\n}\n\n.mobile-dropdown.visible {\n  display: block;\n  padding-bottom: 12px;\n}\n\n.mobile-dropdown-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-width: 1120px;\n  margin: 0 auto;\n}\n\n.mobile-dropdown-item,\n.mobile-dropdown-login {\n  width: 100%;\n  text-align: start;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 14px;\n}\n\n.mobile-dropdown-item {\n  border: 0;\n  background: transparent;\n  color: #334155;\n}\n\n.mobile-dropdown-login {\n  border: 0;\n  background: #0ea5e9;\n  color: #fff;\n  font-weight: 600;\n}\n\n@media (max-width: 900px) {\n  .desktop-navigation {\n    display: none;\n  }\n\n  .mobile-navigation {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
